import React from "react";
import mixpanel from "mixpanel-browser";

import Dialog, { CloseDialog } from "components/Dialog";
import Button from "components/Button";

import classes from "./styles.module.scss";

const formatCount = (value) => Number(value || 0).toLocaleString();

const RunConfirmationModal = ({
    open,
    onClose,
    onProceed,
    communityId,
    availableRuns = 0,
    totalSimulations = 0,
    numToBeRun = 0,
    insufficientRuns = false,
    isPreparingRun = false,
    onUnlockRunsClick,
}) => {
    const proceedDisabled = insufficientRuns || isPreparingRun || numToBeRun === 0;

    return (
        <Dialog open={open}>
            <CloseDialog closeActions={onClose} />
            <div className={classes.dialog}>
                <div className={classes.dialogHeader}>
                    <h3>Simulation Details</h3>
                </div>
                <div className={classes.divider} />

                <div className={classes.row}>
                    <div>Unlocked runs:</div>
                    <strong>{formatCount(availableRuns)}</strong>
                </div>
                <div className={classes.row}>
                    <div>Number of new runs:</div>
                    <strong>{formatCount(numToBeRun)}</strong>
                </div>
                <div className={classes.row}>
                    <div>Total result count after simulation:</div>
                    <strong>{formatCount(totalSimulations)}</strong>
                </div>

                <p className={classes.breakdown}>
                    Includes whole-package combinations, one simulation for each individual measure, and a subset
                    simulation only when it differs from those measures. A base case is included for each ready
                    orientation that has not been run.
                </p>

                <p className={classes.note}>
                    Models and upgrade packages included in this run are locked afterwards, and will be part of any
                    future analysis updates for this community.
                </p>

                {insufficientRuns && (
                    <div className={classes.insufficientRunsText}>
                        <p>
                            {`You have not unlocked enough runs for this community. You need capacity for at least ${formatCount(
                                totalSimulations
                            )} runs. You currently have ${formatCount(availableRuns)} unlocked.`}
                        </p>
                        <Button type="hollow" smallPadding onClick={onUnlockRunsClick}>
                            Unlock Runs
                        </Button>
                    </div>
                )}

                <div className={classes.footer}>
                    <Button type="red" onClick={onClose} disabled={isPreparingRun}>
                        Cancel
                    </Button>
                    <Button
                        onClick={() => {
                            if (proceedDisabled) return;

                            mixpanel.track("Community Analysis Start", {
                                CommunityId: communityId,
                                RunSize: numToBeRun,
                            });

                            onProceed();
                        }}
                        disabled={proceedDisabled}
                    >
                        {isPreparingRun ? "Preparing Run..." : "Proceed"}
                    </Button>
                </div>
            </div>
        </Dialog>
    );
};

export default RunConfirmationModal;
